// extracted by mini-css-extract-plugin
export default {"realized":"VendorsView_realized__Y-vdc","table":"VendorsView_table__q4FHk","toolbar":"VendorsView_toolbar__e9F1K"};